import React, { useEffect, useState, useRef } from "react";
import { Form, Container, Row, Col, Card } from "react-bootstrap";
import { useDispatch } from "react-redux";

import { getFerry } from "../../store/slices/ferry";
import { toast } from "react-toastify";
import { getPlace } from "../../store/slices/place";

export default function EditQuotationFerryStep({
  packageId,
  ferries,
  setFerries,
  nextStep,
  prevStep,
}) {
  const dispatch = useDispatch();


  const [errors, setErrors] = useState([]);
  const [masterFerries, setMasterFerries] = useState({});
  const [places, setPlaces] = useState([]);

  const hasLoadedRoutes = useRef(false);

useEffect(() => {

  const loadPlaces =
    async () => {

      try {

        const res =
          await dispatch(
            getPlace()
          ).unwrap();

        setPlaces(
          res?.places ||
          res?.data ||
          []
        );

      } catch {

        toast.error(
          "Failed to load places"
        );

      }
    };

  loadPlaces();

}, [dispatch]);

  const addFerryRow = (configIndex) => {
    const updated = [...ferries];

    updated[configIndex].ferries.push({
      fromPlace: "",
      toPlace: "",
      ferry: "",
      scheduleIndex: "",
      className: "",
      quantity: 1,
    });

    setFerries(updated);
  };

  const removeFerryRow = (configIndex, ferryIndex) => {
    const updated = [...ferries];

    updated[configIndex].ferries = updated[configIndex].ferries.filter(
      (_, i) => i !== ferryIndex,
    );

    setFerries(updated);
  };

  const handleChange = async (configIndex, ferryIndex, field, value) => {
    const updated = [...ferries];

    const row = {
      ...updated[configIndex].ferries[ferryIndex],
      [field]: value,
    };

    // 🔥 IMPORTANT FIX (reset logic)
    if (field === "ferry") {
      row.scheduleIndex = "";
      row.className = "";
    }


/* =====================================
   CLASS CHANGE
===================================== */

if (
  field === "className"
) {

  const selectedFerryIndex =
    Number(row.ferry);

  const selectedFerry =
    masterFerries[key]?.[
      selectedFerryIndex
    ];

  const selectedSchedule =
    selectedFerry?.schedules?.[
      Number(row.scheduleIndex)
    ];

  const selectedClass =
    selectedSchedule?.classes?.find(
      (cls) =>
        cls.className === value
    );

  if (selectedClass) {

    row.price =
      Number(
        selectedClass.price || 0
      );

    row.costType =
      selectedClass.costType ||
      "perPerson";

    row.ferryName =
      selectedFerry?.name || "";

    row.vendor =
      selectedFerry?.vendor || "";

    row.departureTime =
      selectedSchedule
        ?.departureTime || "";

    row.arrivalTime =
      selectedSchedule
        ?.arrivalTime || "";

    console.log(
      "FERRY PRICE SET",
      row
    );
  }
}



    if (field === "scheduleIndex") {
      row.className = "";
    }

    updated[configIndex].ferries[ferryIndex] = row;

    const key = `${configIndex}_${ferryIndex}`;
    const from = row.fromPlace;
    const to = row.toPlace;

    // existing logic (unchanged)
    if ((field === "fromPlace" || field === "toPlace") && from && to) {
      try {
        const ferryRes = await dispatch(
          getFerry({ from: row.fromPlace?._id || row.fromPlace, to: row.toPlace?._id || row.toPlace, })
        ).unwrap();

        const route = ferryRes?.ferryData?.[0];

        const ferriesList =
          route?.ferries?.map((f, idx) => ({
            id: idx,
            routeId: route._id,
            ferryId: f._id,
            key: `${route._id}_${idx}`,
            name: f.name,
            vendor: f.vendor,
            schedules: f.schedules,
          })) || [];

        setMasterFerries((prev) => ({
          ...prev,
          [key]: ferriesList,
        }));
      } catch {
        toast.error("Failed to load ferries");
      }
    }

    setFerries(updated);
  };

  useEffect(() => {
    if (!ferries.length) return;

    const hasFerryIds = ferries.some((config) =>
      config.ferries?.some((row) => row.ferry),
    );

    if (!hasFerryIds) return;
  if (
  hasLoadedRoutes.current &&
  Object.keys(masterFerries).length > 0
) {
  return;
}
hasLoadedRoutes.current = false;
    hasLoadedRoutes.current = true;

    const loadExistingFerries = async () => {
      // Accumulate ALL master ferry data first
      const newMasterFerries = {};

      // Build a lookup of { ferryKey -> ferryIndex } to apply after
      const ferryIndexUpdates = {}; // key: "i_j" -> ferryIndex number

      for (let i = 0; i < ferries.length; i++) {
        const config = ferries[i];
        if (!config.ferries) continue;

        for (let j = 0; j < config.ferries.length; j++) {
          const row = config.ferries[j];
          if (!row.fromPlace || !row.toPlace || !row.ferry) continue;

          const ferryKey = `${i}_${j}`;

          try {
            const ferryRes = await dispatch(
              getFerry({ from: row.fromPlace, to: row.toPlace }),
            ).unwrap();

            const route = ferryRes?.ferryData?.[0];

            const ferriesList =
              route?.ferries?.map((f, idx) => ({
                id: idx,
                routeId: route._id,
                ferryId: f._id,
                key: `${route._id}_${idx}`,
                name: f.name,
                vendor: f.vendor,
                schedules: f.schedules,
              })) || [];

            // Store in local accumulator — NOT in state yet
            newMasterFerries[ferryKey] = ferriesList;

          const ferryIndex = ferriesList.findIndex( (f) => String(f.ferryId) === String( row.ferry?._id || row.ferry ), );

            if (ferryIndex >= 0) {
              ferryIndexUpdates[ferryKey] = ferryIndex;
            }
          } catch {
            console.log("Failed loading ferry routes for key", ferryKey);
          }
        }
      }

      // Set ALL master ferries at once
      setMasterFerries(newMasterFerries);

      // Now update ferry indices using the accumulated data
      setFerries((prev) => {
        const updated = prev.map((config, i) => ({
          ...config,
          ferries: config.ferries?.map((row, j) => {
            const ferryKey = `${i}_${j}`;
            const ferryIndex = ferryIndexUpdates[ferryKey];
            if (ferryIndex !== undefined) {
              return { ...row, ferry: ferryIndex };
            }
            return row;
          }),
        }));
        return updated;
      });
    };

    loadExistingFerries();
  }, [ferries]);

  const validateFerryForm = () => {
    let isValid = true;
    const newErrors = [];

    ferries.forEach((config, i) => {
      newErrors[i] = {};

      config.ferries?.forEach((row, j) => {
        if (row.ferry === "" || row.ferry === undefined) return;

        if (row.scheduleIndex === "" || row.scheduleIndex === undefined) {
          isValid = false;
        }

        if (!row.className) {
          isValid = false;
        }
      });
    });

    setErrors(newErrors);

    return isValid;
  };

  const copyToAllOptions = (sourceConfig, sourceIndex) => {
  const updatedMasterFerries = { ...masterFerries };

  setFerries((prev) => {
    return prev.map((config, configIndex) => {

      // same day, different option
      if (
        String(config.dayPlan) ===
          String(sourceConfig.dayPlan) &&
        String(config.packageOption) !==
          String(sourceConfig.packageOption)
      ) {

        const copiedFerries = sourceConfig.ferries.map(
          (ferryRow, rowIndex) => {

            // copy master ferry cache also
            const sourceKey = `${sourceIndex}_${rowIndex}`;
            const targetKey = `${configIndex}_${rowIndex}`;

            if (masterFerries[sourceKey]) {
              updatedMasterFerries[targetKey] =
                masterFerries[sourceKey];
            }

            return {
              ...ferryRow,
            };
          },
        );

        return {
          ...config,
          ferries: copiedFerries,
        };
      }

      return config;
    });
  });

  setMasterFerries(updatedMasterFerries);

  toast.success("Copied to all options");
};
  const handleSubmit = async () => {
    if (!validateFerryForm()) return;

    try {
    
      nextStep();
    } catch (err) {
      console.error(err);
      toast.error("Failed to save ferries");
    }
  };


const ferriesByOption =
  Object.values(
    ferries.reduce(
      (acc, ferryConfig) => {

        const optionId =
          ferryConfig.packageOption;

        if (!acc[optionId]) {

          acc[optionId] = {
            option: {
              _id: optionId,

              name:
                ferryConfig
                  ?.packageOptionName ||

                "Option",
            },

            configs: [],
          };
        }

        acc[optionId].configs.push(
          ferryConfig
        );

        return acc;

      },
      {}
    )
  );


  return (
    <Container>
      <Card className="p-4 shadow-sm border-0 mt-2">
        <Row>
          {ferriesByOption.map(({ option, configs }) => (
            <Col md={6} key={option._id}>
              <Card className="p-3 mb-3 shadow-sm">
                <h5 className="text-center mb-3">{option.name}</h5>

                {configs.map((config) => {
                 const actualIndex = ferries.findIndex( (f) => String(f._id) === String(config._id) );

                  return (
                    <Card key={actualIndex} className="mb-3 p-3 border">
                      <h6>Day {configs.indexOf(config) + 1}</h6>

                      {config.ferries.map((row, ferryIndex) => {
                        const ferryKey = `${actualIndex}_${ferryIndex}`;

const selectedFerryIndex =
  row.ferry !== undefined
    ? row.ferry
    : (
        masterFerries[ferryKey]
          ?.findIndex(
            (f) =>
              String(f.ferryId) ===
              String(
                row.ferry?._id ||
                row.ferry
              )
          )
      );

const selectedFerry =
  selectedFerryIndex !==
    undefined &&
  selectedFerryIndex !== -1 &&
  masterFerries[ferryKey]
    ? masterFerries[ferryKey][
        Number(
          selectedFerryIndex
        )
      ]
    : null;

                        return (
                          <Row key={ferryIndex} className="g-3 mb-2">
                            <Col md={6}>
                              <Form.Label>From</Form.Label>
                              <Form.Select
                                value={ row.fromPlace?._id || row.fromPlace || "" }
                                onChange={(e) =>
                                  handleChange(
                                    actualIndex,
                                    ferryIndex,
                                    "fromPlace",
                                    e.target.value,
                                  )
                                }
                              >
                                <option value="">Select</option>
                                {places
                                 .filter( (p) => String(p._id) !== String( row.toPlace?._id || row.toPlace ) )
                                  .map((p) => (
                                    <option key={p._id} value={p._id}>
                                      {p.name}
                                    </option>
                                  ))}
                              </Form.Select>
                            </Col>

                            {/* To */}
                            <Col md={6}>
                              <Form.Label>To</Form.Label>
                              <Form.Select
                               value={ row.toPlace?._id || row.toPlace || "" }
                                onChange={(e) =>
                                  handleChange(
                                    actualIndex,
                                    ferryIndex,
                                    "toPlace",
                                    e.target.value,
                                  )
                                }
                              >
                                <option value="">Select</option>
                                {places
                                 .filter( (p) => String(p._id) !== String( row.fromPlace?._id || row.fromPlace ) )
                                  .map((p) => (
                                    <option key={p._id} value={p._id}>
                                      {p.name}
                                    </option>
                                  ))}
                              </Form.Select>
                            </Col>

                            <Col md={6}>
                              <Form.Label>Ferry</Form.Label>
                              <Form.Select
                           value={ typeof row.ferry === "number" ? row.ferry : ( masterFerries[ferryKey] ?.findIndex( (f) => String(f.ferryId) === String( row.ferry?._id || row.ferry ) ) ) ?? "" }
                                disabled={!row.fromPlace || !row.toPlace}
                                onChange={(e) =>
                                  handleChange(
                                    actualIndex,
                                    ferryIndex,
                                    "ferry",
                                    e.target.value,
                                  )
                                }
                              >
                                <option value="">Select Ferry</option>

                                {(masterFerries[ferryKey] || []).map((f) => (
                                  <option key={f.key} value={f.id}>
                                    {f.name}
                                  </option>
                                ))}
                              </Form.Select>
                            </Col>

                            {selectedFerry && (
                              <Col md={6}>
                                <Form.Label>Schedule</Form.Label>
                                <Form.Select
                                  value={row.scheduleIndex}
                                  onChange={(e) =>
                                    handleChange(
                                      actualIndex,
                                      ferryIndex,
                                      "scheduleIndex",
                                      Number(e.target.value),
                                    )
                                  }
                                >
                                  <option value="">Select Schedule</option>

                                  {selectedFerry.schedules.map((sch, i) => (
                                    <option key={i} value={i}>
                                      {sch.departureTime} → {sch.arrivalTime}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Col>
                            )}

                            {/* Class */}
                            {selectedFerry &&
                              row.scheduleIndex !== undefined &&
row.scheduleIndex !== null &&
                             selectedFerry.schedules?.[Number(row.scheduleIndex)] && (
                                <Col md={6}>
                                  <Form.Label>Class</Form.Label>
                                  <Form.Select
                                    value={row.className}
                                    onChange={(e) =>
                                      handleChange(
                                        actualIndex,
                                        ferryIndex,
                                        "className",
                                        e.target.value,
                                      )
                                    }
                                  >
                                    <option value="">Select Class</option>

                                    {selectedFerry.schedules[
  Number(row.scheduleIndex)
]?.classes?.map((cls, i) => (
                                      <option key={i} value={cls.className}>
                                      {cls.className} (₹{ row.price || cls.price })
                                      </option>
                                    ))}
                                  </Form.Select>
                                </Col>
                              )}

                            <Col md={6}>
                              <button
                                type="button"
                                className="btn btn-danger btn-sm mt-4"
                                onClick={() =>
                                  removeFerryRow(actualIndex, ferryIndex)
                                }
                              >
                                ✕
                              </button>
                            </Col>
                          </Row>
                        );
                      })}

                     <div className="d-flex gap-2 mt-2">
  <button
    type="button"
    className="cancel-btn btn-sm" 
    onClick={() => addFerryRow(actualIndex)}
  >
    + Add Ferry
  </button>

  <button
    type="button"
    className="cancel-btn btn-sm"
    onClick={() => copyToAllOptions(config, actualIndex)}
  >
    Copy To All
  </button>
</div>
                    </Card>
                  );
                })}
              </Card>
            </Col>
          ))}
        </Row>

       
      </Card>
    </Container>
  );
}
